import { gatherRules } from "../";
import { i18n } from "@/services/vue-i18n";

export default {
  event: {
    title: gatherRules("app.required", "app.text.small"),
    rendering: [
      v =>
        !v ||
        v === "background" ||
        v === "inverse-background" ||
        i18n.t("validation.scheduler.event.rendering")
    ],
    shortDescription: gatherRules(
      "app.required",
      "app.text.min",
      "app.text.small"
    ),
    longDescription: gatherRules("app.text.min", "app.text.default")
  },
  session: {
    description: gatherRules("app.required", "app.text.min", "app.text.small"),
    maxEvents: [
      v => !v || v <= 30 || i18n.tc("validation.general.numbers.max", 30)
    ],
    recurrence: [
      v =>
        !v ||
        v === i18n.t("scheduler.session.recurrence.daily") ||
        v === i18n.t("scheduler.session.recurrence.weekly") ||
        v === i18n.t("scheduler.session.recurrence.monthly") ||
        i18n.t("validation.scheduler.session.recurrence")
    ]
  }
};
